import { colors } from 'fitify-ui'
import { tabletPortrait } from 'fitify-ui-landing/src/theme/breakpoints'
import Link from 'next/link'
import styled, { css } from 'styled-components'

export const StyledFooter = styled.div`
  padding-top: 80px;
  padding-bottom: 30px;
  border-radius: 40px 40px 0 0;
  background: ${colors.Mantis500};

  ${tabletPortrait(css`
    padding-top: 40px;
    border-radius: 24px 24px 0 0;
    margin-top: 24px;
  `)};
`

export const StyledFooterGrid = styled.div`
  display: flex;
  justify-content: space-between;

  ${tabletPortrait(css`
    flex-direction: column;
  `)};
`

export const StyledFooterBrandImage = styled(Link)`
  cursor: pointer;
`

export const StyledFooterStoreIcons = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  gap: 24px;

  a {
    &:hover {
      opacity: 0.55;
    }
  }
`

export const StyledFooterImagesColumn = styled.div`
  display: flex;
  width: max-content;
  flex-direction: column;

  ${tabletPortrait(css`
    order: 2;

    ${StyledFooterStoreIcons} {
      order: 1;
      margin-top: 0;
      margin-bottom: 80px;
    }

    ${StyledFooterBrandImage} {
      order: 2;
    }
  `)};
`

export const StyledFooterMenuColumn = styled.div`
  display: flex;
  width: 100%;
  max-width: 480px;
  justify-content: space-between;

  ${tabletPortrait(css`
    flex-direction: column;
    margin-bottom: 80px;
    gap: 80px;
  `)};
`

export const StyledFooterCopy = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 120px;

  ul {
    margin-top: 0;
  }

  ${tabletPortrait(css`
    flex-direction: column;
    align-items: flex-start;
    margin-top: 64px;
    gap: 16px;
  `)};
`

export const StyledNavigationMenuWrapper = styled.div`
  flex: 1;
  justify-items: flex-end;
`
